import { Outlet, createFileRoute } from '@tanstack/react-router';

import { ViewedCompanyProvider } from '@/hooks/useViewedCompanyID';
import { requireAnyPermission } from '@/lib/route-guards/permission-guard';
import { MemberScopeFallback } from '@/pages/chain/MemberScopeFallback';
import { useMemberCompany } from '@/pages/chain/useMemberCompany';

// The parent stays bound to its own company (ADR-0025); only the tenant in view changes, so every
// page under this scope reads the member's data without the store ever swapping companies.
function MemberScope() {
	const { memberCompanyId, isLoading } = useMemberCompany();

	if (isLoading) return <MemberScopeFallback state="loading" />;
	if (!memberCompanyId) return <MemberScopeFallback state="missing" />;

	return (
		<ViewedCompanyProvider companyId={memberCompanyId}>
			<Outlet />
		</ViewedCompanyProvider>
	);
}

export const Route = createFileRoute('/_authenticated/_app/chain/companies/$memberId')({
	beforeLoad: ({ context }) =>
		requireAnyPermission({ context, anyOf: ['chainHq.read', 'chainHq.readAnalytics'], redirectTo: '/dashboard' }),
	component: MemberScope,
});
